import React from 'react';
const stats = [{
  value: '+800',
  label: 'Personas confían en el sistema'
}, {
  value: '4.9/5',
  label: 'Valoración promedio'
}, {
  value: '+180',
  label: 'Recursos técnicos y protocolos'
}, {
  value: '#1',
  label: 'Sistema elegido en Argentina'
}];
export function StatsBar() {
  return <section className="py-8 md:py-16 px-4 sm:px-6 lg:px-8 bg-zinc-900/50 border-y border-zinc-800/50" data-id="element-120">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8" data-id="element-121">
        {stats.map((stat, i) => <div key={i} className="text-center" data-id="element-122">
            <div className="text-3xl md:text-5xl font-bold text-[#00b8ff] mb-1 md:mb-2" data-id="element-123">
              {stat.value}
            </div>
            <div className="text-xs md:text-sm text-zinc-400 leading-tight" data-id="element-124">
              {stat.label}
            </div>
          </div>)}
      </div>
    </section>;
}